import QRCode from 'react-qr-code';
import styled from 'styled-components/macro';

interface Props {
    url?: string;
    className?: string;
}

export const ScanQrCode = (props: Props) => {
    return (
        <S_ScanQrCode className={props.className}>
            <S_QRCode value={props.url ?? location.origin + location.pathname} />
        </S_ScanQrCode>
    );
};

const S_ScanQrCode = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const S_QRCode = styled(QRCode)`
    max-width: 100%;
    width: 100%;
    height: auto;
`;
